"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "careggine": {
    "9da5fecf": [{
      "hkey": "f2df994f",
      "slug": "careggine",
      "name": "Careggine",
      "primary": true,
      "skipSearch": false
    }],
    "capricchia": [{
      "hkey": "f2df994f",
      "slug": "careggine",
      "name": "Careggine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b3413a5c": [{
      "hkey": "f2df994f",
      "slug": "careggine",
      "name": "Careggine",
      "primary": true,
      "skipSearch": false
    }],
    "ferriera": [{
      "hkey": "f2df994f",
      "slug": "careggine",
      "name": "Careggine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "86a6b5ef": [{
      "hkey": "f2df994f",
      "slug": "careggine",
      "name": "Careggine",
      "primary": true,
      "skipSearch": false
    }],
    "la-foce": [{
      "hkey": "f2df994f",
      "slug": "careggine",
      "name": "Careggine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f39218a4": [{
      "hkey": "5fb8e6e9",
      "slug": "le-coste",
      "name": "Le Coste",
      "primary": true,
      "skipSearch": false
    }],
    "le-copste": [{
      "hkey": "5fb8e6e9",
      "slug": "le-coste",
      "name": "Le Coste",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c77d9619": [{
      "hkey": "f2df994f",
      "slug": "careggine",
      "name": "Careggine",
      "primary": true,
      "skipSearch": false
    }],
    "vergaia": [{
      "hkey": "f2df994f",
      "slug": "careggine",
      "name": "Careggine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;